export default {
  title: "Search contacts",
  name: {
    label: "Name",
    placeholder: "Search on contact name"
  }
}
